module.exports = __webpack_public_path__ + "img/W-5.43e7feaf.jpg";